// @flow
export const FUNNEL_WAG_TAG = 'WagTag';
export const FUNNEL_WAG_TAG_BASIC = 'WagTagBasic';
export const FUNNEL_WAG_TAG_PLUS = 'WagTagPlus';

export type TrackingFunnel = typeof FUNNEL_WAG_TAG
| typeof FUNNEL_WAG_TAG_BASIC
| typeof FUNNEL_WAG_TAG_PLUS;
